import * as React from "react";

import { WeekdayNameType } from "../../../classes/recurrencePattern";
import { IText } from "../../../classes/text";

import { RecurrencePatternWeekly_RepeatsEveryDropdown } from "./RecurrencePatternWeekly_RepeatsEveryDropdown";
import { RecurrencePatternWeekly_RepeatsOnWeekDaysCheckboxes } from "./RecurrencePatternWeekly_RepeatsOnWeekdaysCheckboxes";

export interface IRecurrencePatternWeekly {
	firstDayOfWeek: string;
	isTwoWayCalendar: boolean;
	onChangeRepeatsEveryXWeeks: (repeatEveryXWeeks: number) => void;
	onChangeRepeatsOnWeekdays: (repeatsOnWeekdays: WeekdayNameType[]) => void;
	repeatEveryXWeeks: number;
	repeatsOnWeekDays: WeekdayNameType[];
	saveHasBeenClicked: boolean;
	text: IText;
	validationAtLeastOneDayIsTicked: boolean;
}

export const RecurrencePatternWeekly: React.SFC<IRecurrencePatternWeekly> = (props) => {
	return (
		<>
			<RecurrencePatternWeekly_RepeatsEveryDropdown
				isTwoWayCalendar={props.isTwoWayCalendar}
				onChangeRepeatsEveryXWeeks={props.onChangeRepeatsEveryXWeeks}
				repeatEveryXWeeks={props.repeatEveryXWeeks}
				text={props.text}
			/>

			<RecurrencePatternWeekly_RepeatsOnWeekDaysCheckboxes
				firstDayOfWeek={props.firstDayOfWeek}
				onChangeRepeatsOnWeekdays={props.onChangeRepeatsOnWeekdays}
				repeatsOnWeekDays={props.repeatsOnWeekDays}
				saveHasBeenClicked={props.saveHasBeenClicked}
				text={props.text}
				validationAtLeastOneDayIsTicked={props.validationAtLeastOneDayIsTicked}
			/>
		</>
	);
};
